import React from 'react';
import {
  Divider, Form, Radio, CheckBox, Icon,
} from '@roo/roo';
import { getLableByValue } from '@utils/positionTitle';
import { useUserData } from '@components/UserData';
import {
  renderDetailListByColumns,
  defaultCols as cols,
  renderFileForPreview,
  renderTextArea,
  Area,
} from './util';

import '../index.scss';

const { Group: RadioGroup } = Radio;

const scientistColumns = [{
  label: '专家姓名',
  key: 'authName',
}, {
  label: '单位名称',
  key: 'authCompany',
}, {
  label: <span>职&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;务</span>,
  key: 'position',
}, {
  label: <span>职&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;称</span>,
  key: 'positionalTitle',
  _render: (record) => {
    const { positionalTitle } = record;
    return getLableByValue(positionalTitle);
  },
}, {
  label: <span>&nbsp;&nbsp;手&nbsp;&nbsp;机&nbsp;&nbsp;号</span>,
  key: 'phone',
  required: false,
},
{
  label: <span>邮&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;箱</span>,
  key: 'email',
},
{
  label: <span>学&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;科</span>,
  key: 'studyArea',
  _render: (item) => {
    const {
      studyAreaType,
      studyAreaPath,
    } = item;
    return (
      <div>
        <RadioGroup value={studyAreaType}>
          <Radio value={1}>专一领域</Radio>
          <Radio value={2}>交叉领域</Radio>
        </RadioGroup>
        <div style={{ marginTop: '10px' }}>
          <Area value={studyAreaPath} />
        </div>
      </div>
    );
  },
},
{
  label: '研究方向',
  key: 'researchDirection',
}];

const paperColumns = [{
  label: <span>篇&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名</span>,
  key: 'paperName',
}, {
  label: <span>期&nbsp;&nbsp;刊&nbsp;&nbsp;名</span>,
  key: 'journalName',
}, {
  label: '发表时间',
  key: 'publishTime',
}, {
  label: '署名情况',
  key: 'authorType',
}, {
  label: '主要合作作者',
  key: 'mainCoAuthor',
}, {
  label: '他引次数',
  key: 'referenceNumber',
}, {
  label: '论文上传',
  key: 'paperUrl',
  layout: 'vertical',
  _render: renderFileForPreview,
}];

const honorColumns = [{
  label: '获奖时间',
  key: 'getTime',
}, {
  label: '奖项名称',
  key: 'honorName',
}, {
  label: '授奖机构',
  key: 'institutionName',
}, {
  label: '等级排名',
  key: 'honorRank',
}, {
  label: '原因贡献',
  key: 'description',
  className: 'form-group-flex-start',
  _render: renderTextArea,
}, {
  label: '证书上传',
  key: 'fileUrl',
  layout: 'vertical',
  _render: renderFileForPreview,
}];

const patentColumns = [{
  label: <span>国&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;别</span>,
  key: 'nation',
}, {
  label: '产权类别',
  key: 'type',
}, {
  label: '产权名称',
  key: 'name',
}, {
  label: <span>名&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;次</span>,
  key: 'rank',
}, {
  label: '产权编号',
  key: 'fileNumber',
}, {
  label: '知识产权文件上传',
  key: 'fileUrl',
  layout: 'vertical',
  _render: (item) => renderFileForPreview(item, 'fileUrl'),
}];

const resultColumns = [{
  key: 'paper',
  label: '代表性论文（必填）',
  desc: '请提供不超过五篇本人发表的，与工作规划相关的代表性论文、著作，建议填写申报人作为一作或通讯作者发表的作品。',
  _render: (paperList) => renderDetailListByColumns(paperList, paperColumns),
}, {
  key: 'honor',
  label: '个人曾获学术奖励',
  desc: '若有，请提供不超过三项，曾获得的重要学术荣誉',
  _render: (honorList) => renderDetailListByColumns(honorList, honorColumns),
}, {
  label: '知识产权情况',
  key: 'patent',
  desc: '若有，请提供不超过五项，与项目内容相关的授权知识产品',
  _render: (patentList) => renderDetailListByColumns(patentList, patentColumns),
}];

export default ({ detail: studyInfo, isView }) => {
  const {
    authScientist, studyAreaType, studyAreaPath, studyIssues,
  } = studyInfo;
  const { sciTopicList } = useUserData();
  return (
    <>
      <h3 id="studyAreaPath" className="catalogue-tag">申报人所属科学领域</h3>
      <Divider />
      <div className="preview-item-wrap">
        <div className="preview-item-wrap-withoutbackground">
          <Form.Field
            label="学科领域"
            required
            cols={cols}
            className="preview-item-text"
          >
            <RadioGroup value={studyAreaType}>
              <Radio value={1}>专一领域</Radio>
              <Radio value={2}>交叉领域</Radio>
            </RadioGroup>
            <div style={{ marginTop: '10px' }}>
              <Area value={studyAreaPath} />
            </div>
          </Form.Field>
        </div>
      </div>
      {
        !isView && (
          <>
            <h3 id="authScientist" className="catalogue-tag">领域内权威专家</h3>
            <Divider />
            {
              renderDetailListByColumns(authScientist, scientistColumns)
            }
          </>
        )
      }
      <h3 id="studyIssues" className="catalogue-tag">科研议题</h3>
      <Divider />
      <div className="preview-item-wrap ">
        <div className="preview-item-wrap-withoutbackground">
          <Form cols={cols}>
            <Form.Field
              layout="vertical"
              label="相关议题"
              required
              className="preview-item-text"
            >
              <div>
                <Icon name="info-circle-o" className="preview-item-desc" />
                <span className="preview-item-desc">
                青山科技奖申报人的研究方向及规划需覆盖以下议题之一，最多可选择两个相关议题
                </span>
              </div>
              <div>
                <CheckBox.Group value={studyIssues || undefined}>
                  {(sciTopicList || []).map((item, index) => (
                    <CheckBox
                      key={index}
                      value={Number(item.id)}
                      disabled
                    >
                      {item.name}
                    </CheckBox>
                  ))}
                </CheckBox.Group>
              </div>
            </Form.Field>
          </Form>
        </div>
      </div>
      <h3 id="result" className="catalogue-tag">学术成果</h3>
      <Divider />
      <div className="preview-item-wrap preview-item-flex-direction">
        <Form cols={cols} layout="vertical">
          {
            resultColumns.map((itemColumn) => {
              const {
                key, label, _render, desc,
              } = itemColumn;
              return (
                <Form.Field
                  label={label}
                  required
                  className="preview-item-text"
                >
                  {
                    desc ? (
                      <div style={{ marginLeft: '80px' }}>
                        <Icon name="info-circle-o" className="preview-item-desc" />
                        <span className="preview-item-desc">{desc}</span>
                      </div>
                    ) : null
                  }
                  {_render(studyInfo[key])}
                </Form.Field>
              );
            })
          }
        </Form>
      </div>
    </>
  );
};
